export default "__VITE_ASSET__56cf907c__"